import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const ArrowUp = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.29303 9.70703C3.10556 9.5195 3.00024 9.26519 3.00024 9.00003C3.00024 8.73487 3.10556 8.48056 3.29303 8.29303L9.29303 2.29303C9.48056 2.10556 9.73487 2.00024 10 2.00024C10.2652 2.00024 10.5195 2.10556 10.707 2.29303L16.707 8.29303C16.8892 8.48163 16.99 8.73423 16.9877 8.99643C16.9854 9.25863 16.8803 9.50944 16.6948 9.69485C16.5094 9.88026 16.2586 9.98543 15.9964 9.9877C15.7342 9.98998 15.4816 9.88919 15.293 9.70703L11 5.41403V17C11 17.2652 10.8947 17.5196 10.7071 17.7071C10.5196 17.8947 10.2652 18 10 18C9.73481 18 9.48046 17.8947 9.29292 17.7071C9.10539 17.5196 9.00003 17.2652 9.00003 17V5.41403L4.70703 9.70703C4.5195 9.8945 4.26519 9.99982 4.00003 9.99982C3.73487 9.99982 3.48056 9.8945 3.29303 9.70703Z'
      />
    </svg>
  );
};
